'use client';
import { useSession, signOut } from 'next-auth/react';
import { useCallback, useMemo, type ReactNode } from 'react';
import { clearToken } from './auth.service';
import type { AuthContextValue } from './auth.types';
export function AuthProvider({ children }: { children: ReactNode }) { return <>{children}</>; }
export function useAuth(): AuthContextValue {
  const { data: session, status } = useSession();
  const logout = useCallback(async () => {
    clearToken();
    await signOut({ redirect: true, redirectTo: '/signin' });
  }, []);
  return useMemo(() => ({
    // Compatibility marker: session cookies authenticate API requests.
    token: status === 'authenticated' ? 'session' : null,
    user: session?.user ? { userId: session.user.id || '', username: session.user.name || '', email: session.user.email || '' } : null,
    isLoading: status === 'loading',
    isAuthorized: status === 'authenticated' && !!session?.user,
    logout,
  }), [session, status, logout]);
}
